import { c as _c } from "react/compiler-runtime";
import { RadioGroup } from '@/shared/components/ui';
import type { ModoDaSimulacao, ModoDaSimulacaoDoAdminProps } from '../types';
const ehModo = (valor: string): valor is ModoDaSimulacao => valor === 'RASCUNHO' || valor === 'PUBLICADA';

/**
 * "Rascunho salvo" ou "Versão publicada" antes de Iniciar (CA-17). Só a opção indisponível sai
 * desabilitada, com o motivo ligado a ela (CA-15).
 */
export const ModoDaSimulacaoDoAdmin = t0 => {
  const $ = _c(12);
  const {
    opcoes,
    modo,
    disabled,
    onChange
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = valor => {
      if (ehModo(valor)) {
        onChange(valor);
      }
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const alterar = t1;
  const t2 = modo ?? "";
  let t3;
  if ($[2] !== disabled || $[3] !== opcoes) {
    let t4;
    if ($[5] !== disabled) {
      t4 = opcao => <div key={opcao.modo} className="flex flex-col gap-0.5"><RadioGroup.Option value={opcao.modo} label={opcao.rotulo} disabled={disabled || !opcao.disponivel} aria-describedby={opcao.motivo ? `modo-${opcao.modo}-motivo` : undefined} />{opcao.motivo && <span id={`modo-${opcao.modo}-motivo`} className="text-caption text-subtext-color pl-6">{opcao.motivo}</span>}</div>;
      $[5] = disabled;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = opcoes.map(t4);
    $[2] = disabled;
    $[3] = opcoes;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== alterar || $[8] !== disabled || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className="mt-6"><RadioGroup label={"Configura\xE7\xE3o do teste"} helpText={"Trocar a configura\xE7\xE3o encerra o teste em andamento."} value={t2} onValueChange={alterar} disabled={disabled}>{t3}</RadioGroup></div>;
    $[7] = alterar;
    $[8] = disabled;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};